import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
import UDropdownMenu from "@/components/uikit/uComponents/UDropdownMenu.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TableDropdownMenu',
    props: {
        items: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_UIcon = _resolveComponent("UIcon");
            const _component_UButton = _resolveComponent("UButton");
            const _directive_ripple = _resolveDirective("ripple");
            return (_openBlock(), _createBlock(UDropdownMenu, { items: __props.items }, {
                button: _withCtx(({ toggle }) => [
                    _createVNode(_component_UButton, {
                        severity: "transparent",
                        onClick: toggle
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_UIcon, { icon: "more" })
                        ]),
                        _: 1
                    }, 8, ["onClick"])
                ]),
                item: _withCtx(({ item, props }) => [
                    _withDirectives((_openBlock(), _createElementBlock("a", _mergeProps({ class: "flex items-center" }, props.action), [
                        _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ], 16)), [
                        [_directive_ripple]
                    ])
                ]),
                _: 1
            }, 8, ["items"]));
        };
    }
});
